// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@disy/cadenza-icons/check.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("@disy/cadenza-icons/info.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("@disy/cadenza-icons/warning.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("@disy/cadenza-icons/error.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.d-alert {
  --bg: transparent;
  --color: var(--default-color);
  --font-size: var(--default-font-size);
  --icon: none;
  --icon-color: var(--color);
  --icon-gap: 4px;
  --icon-size: 20px;
  --line-height: var(--default-line-height);
  --padding-x: 8px;
  --padding-y: 12px;
  --text-offset: calc((var(--icon-size) - var(--line-height))/2);
  --p-margin: 8px;

  background-color: var(--bg);
  color: var(--color);
  display: block;
  font-family: var(--default-font-family);
  font-size: var(--font-size);
  line-height: var(--line-height);
  padding: calc(var(--padding-y) + var(--text-offset)) var(--padding-x);
  position: relative;
  text-align: left;
}

.d-alert:where(.d-alert-success,.d-alert-info,.d-alert-warning,.d-alert-error):where(.d-alert-with-button) .d-alert--text::before,.d-alert:where(.d-alert-success,.d-alert-info,.d-alert-warning,.d-alert-error):where(:not(.d-alert-with-button))::before {
      background-color: var(--icon-color);
      content: '';
      display: block;
      height: var(--icon-size);
      -webkit-mask-image: var(--icon);
              mask-image: var(--icon);
      -webkit-mask-size: var(--icon-size);
              mask-size: var(--icon-size);
      width: var(--icon-size);
    }

.d-alert:not(.d-alert-small,.d-alert-xs) {
    padding-left: calc(var(--padding-x) + var(--icon-size) + var(--icon-gap));
  }

.d-alert.d-alert-with-button:not(.d-alert-small,.d-alert-xs) .d-alert--text::before,.d-alert:not(.d-alert-small,.d-alert-xs):not(.d-alert-with-button)::before {
      left: var(--padding-x);
      position: absolute;
      top: var(--padding-y);
    }

.d-alert:empty {
    display: none;
  }

.d-alert:where(:not(:last-child)) {
    margin-bottom: 16px;
  }

.d-alert .d-alert--text {
    display: block;
  }

.d-alert p:not(:last-child) {
    margin-bottom: var(--p-margin);
  }

.d-alert ul {
    list-style: square inside;
    margin-bottom: 4px;
    margin-top: 4px;
    padding: 0;

    /* reduce distance between bullet point and text to 4px */
  }

:is(.d-alert ul) li span {
      left: -6px;
      position: relative;
    }

/* reset legacy CSS (/wps/style.css) */

.d-alert .title {
    font-weight: var(--bold-font-weight);
    padding: 0;
    text-align: left;
    width: auto;
  }

:is(.d-alert .title):empty {
      display: none;
    }

.d-alert-success {
  --bg: var(--alert-color-success-background);
  --color: var(--alert-color-success);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.d-alert-info {
  --bg: var(--alert-color-info-background);
  --color: var(--alert-color-info);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.d-alert-warning {
  --bg: var(--alert-color-warning-background);
  --color: var(--alert-color-warning);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
  --icon-color: var(--color-warning-dark);
}

.d-alert-error {
  --bg: var(--alert-color-error-background);
  --color: var(--alert-color-error);
  --icon: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.d-alert-info:where(.d-alert-opaque) {
    --bg: var(--alert-color-info-background-opaque);
  }

.d-alert-warning:where(.d-alert-opaque) {
    --bg: var(--alert-color-warning-background-opaque);
  }

.d-alert-error:where(.d-alert-opaque) {
    --bg: var(--alert-color-error-background-opaque);
  }

:where(.d-alert-xs).d-alert-warning {
  --color: var(--color-warning-dark);
}

.d-alert-with-button:is(.d-alert-small,.d-alert-xs) .d-alert--text::before,:is(.d-alert-small,.d-alert-xs):not(.d-alert-with-button)::before {
    float: left;
    margin-right: var(--icon-gap);
    margin-top: calc(var(--text-offset)*-1);
  }

/*
 * Unfortunately, the alert size default is not sensible, because usually we use the small size.
 * To mitigate issues with people forgetting to apply the small size, we make default alerts
 * *look* like small alerts in modals and popups.
 */

:where(.d-modal, .d-popup) .d-alert,
.d-alert-small {
  --icon-size: 16px;
  --padding-y: 8px;
  --p-margin: 4px;
}

:is(:where(.d-modal,.d-popup) .d-alert,.d-alert-small):where(:not(:last-child)) {
    margin-bottom: 6px;
  }

.d-alert-xs {
  --bg: transparent;
  --icon-gap: 2px;
  --p-margin: 4px;

  padding: 0;
}

.d-alert-xs:where(:not(:last-child)) {
    margin-bottom: 4px;
  }

@media (hover: hover) {

.d-alert-xs {
    --icon-size: 16px; /* icon size 'xs' */
}
  }

.d-alert-with-button {
  align-items: flex-start;
  display: flex;
  justify-content: space-between;
}

.d-alert-with-button .d-alert--text + * {
    margin-left: 8px;
  }

.d-alert-with-button-bottom {
  --button-gap: 8px;
}

.d-alert-with-button-bottom .d-alert--text ~ * {
    margin: var(--button-gap) var(--button-gap) 0 0;
  }

.d-alert-with-button-bottom.d-alert-small {
    --button-gap: 4px;
  }
`, "",{"version":3,"sources":["webpack://./src/ui/alert/alert.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,qCAAqC;EACrC,YAAY;EACZ,0BAA0B;EAC1B,eAAe;EACf,iBAAiB;EACjB,yCAAyC;EACzC,gBAAgB;EAChB,iBAAiB;EACjB,8DAAgE;EAChE,eAAe;;EAEf,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,uCAAuC;EACvC,2BAA2B;EAC3B,+BAA+B;EAC/B,qEAAqE;EACrE,kBAAkB;EAClB,gBAAgB;AAkElB;;AA/DI;MAEE,mCAAmC;MACnC,WAAW;MACX,cAAc;MACd,wBAAwB;MACxB,+BAAuB;cAAvB,uBAAuB;MACvB,mCAA2B;cAA3B,2BAA2B;MAC3B,uBAAuB;IACzB;;AAGF;IACE,yEAAyE;EAQ3E;;AANE;MAEE,sBAAsB;MACtB,kBAAkB;MAClB,qBAAqB;IACvB;;AAGF;IACE,aAAa;EACf;;AAEA;IACE,mBAAmB;EACrB;;AAEA;IACE,cAAc;EAChB;;AAEA;IACE,8BAA8B;EAChC;;AAEA;IACE,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,UAAU;;IAEV,yDAAyD;EAK3D;;AAJE;MACE,UAAU;MACV,kBAAkB;IACpB;;AAGF,sCAAsC;;AACtC;IACE,oCAAoC;IACpC,UAAU;IACV,gBAAgB;IAChB,WAAW;EAKb;;AAHE;MACE,aAAa;IACf;;AAIJ;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,+CAA6C;AAC/C;;AAEA;EACE,wCAAwC;EACxC,gCAAgC;EAChC,+CAA4C;AAC9C;;AAEA;EACE,2CAA2C;EAC3C,mCAAmC;EACnC,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,yCAAyC;EACzC,iCAAiC;EACjC,+CAA6C;AAC/C;;AAGE;IACE,+CAA+C;EACjD;;AAEA;IACE,kDAAkD;EACpD;;AAEA;IACE,gDAAgD;EAClD;;AAGF;EACE,kCAAkC;AACpC;;AAIE;IAEE,WAAW;IACX,6BAA6B;IAC7B,uCAAyC;EAC3C;;AAGF;;;;EAIE;;AACF;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;AAKjB;;AAHE;IACE,kBAAkB;EACpB;;AAGF;EACE,iBAAiB;EACjB,eAAe;EACf,eAAe;;EAEf,UAAU;AASZ;;AAPE;IACE,kBAAkB;EACpB;;AAEA;;AAXF;IAYI,iBAAiB,EAAE,mBAAmB;AAE1C;EADE;;AAGF;EACE,uBAAuB;EACvB,aAAa;EACb,8BAA8B;AAKhC;;AAHE;IACE,gBAAgB;EAClB;;AAGF;EACE,iBAAiB;AASnB;;AAPE;IACE,+CAA+C;EACjD;;AAEA;IACE,iBAAiB;EACnB","sourcesContent":[".d-alert {\n  --bg: transparent;\n  --color: var(--default-color);\n  --font-size: var(--default-font-size);\n  --icon: none;\n  --icon-color: var(--color);\n  --icon-gap: 4px;\n  --icon-size: 20px;\n  --line-height: var(--default-line-height);\n  --padding-x: 8px;\n  --padding-y: 12px;\n  --text-offset: calc((var(--icon-size) - var(--line-height)) / 2);\n  --p-margin: 8px;\n\n  background-color: var(--bg);\n  color: var(--color);\n  display: block;\n  font-family: var(--default-font-family);\n  font-size: var(--font-size);\n  line-height: var(--line-height);\n  padding: calc(var(--padding-y) + var(--text-offset)) var(--padding-x);\n  position: relative;\n  text-align: left;\n\n  &:where(.d-alert-success, .d-alert-info, .d-alert-warning, .d-alert-error) {\n    &:where(.d-alert-with-button) .d-alert--text::before,\n    &:where(:not(.d-alert-with-button))::before {\n      background-color: var(--icon-color);\n      content: '';\n      display: block;\n      height: var(--icon-size);\n      mask-image: var(--icon);\n      mask-size: var(--icon-size);\n      width: var(--icon-size);\n    }\n  }\n\n  &:not(.d-alert-small, .d-alert-xs) {\n    padding-left: calc(var(--padding-x) + var(--icon-size) + var(--icon-gap));\n\n    &.d-alert-with-button .d-alert--text::before,\n    &:not(.d-alert-with-button)::before {\n      left: var(--padding-x);\n      position: absolute;\n      top: var(--padding-y);\n    }\n  }\n\n  &:empty {\n    display: none;\n  }\n\n  &:where(:not(:last-child)) {\n    margin-bottom: 16px;\n  }\n\n  & .d-alert--text {\n    display: block;\n  }\n\n  & p:not(:last-child) {\n    margin-bottom: var(--p-margin);\n  }\n\n  & ul {\n    list-style: square inside;\n    margin-bottom: 4px;\n    margin-top: 4px;\n    padding: 0;\n\n    /* reduce distance between bullet point and text to 4px */\n    & li span {\n      left: -6px;\n      position: relative;\n    }\n  }\n\n  /* reset legacy CSS (/wps/style.css) */\n  & .title {\n    font-weight: var(--bold-font-weight);\n    padding: 0;\n    text-align: left;\n    width: auto;\n\n    &:empty {\n      display: none;\n    }\n  }\n}\n\n.d-alert-success {\n  --bg: var(--alert-color-success-background);\n  --color: var(--alert-color-success);\n  --icon: url('~@disy/cadenza-icons/check.svg');\n}\n\n.d-alert-info {\n  --bg: var(--alert-color-info-background);\n  --color: var(--alert-color-info);\n  --icon: url('~@disy/cadenza-icons/info.svg');\n}\n\n.d-alert-warning {\n  --bg: var(--alert-color-warning-background);\n  --color: var(--alert-color-warning);\n  --icon: url('~@disy/cadenza-icons/warning.svg');\n  --icon-color: var(--color-warning-dark);\n}\n\n.d-alert-error {\n  --bg: var(--alert-color-error-background);\n  --color: var(--alert-color-error);\n  --icon: url('~@disy/cadenza-icons/error.svg');\n}\n\n:where(.d-alert-opaque) {\n  &.d-alert-info {\n    --bg: var(--alert-color-info-background-opaque);\n  }\n\n  &.d-alert-warning {\n    --bg: var(--alert-color-warning-background-opaque);\n  }\n\n  &.d-alert-error {\n    --bg: var(--alert-color-error-background-opaque);\n  }\n}\n\n:where(.d-alert-xs).d-alert-warning {\n  --color: var(--color-warning-dark);\n}\n\n.d-alert-small,\n.d-alert-xs {\n  &.d-alert-with-button .d-alert--text::before,\n  &:not(.d-alert-with-button)::before {\n    float: left;\n    margin-right: var(--icon-gap);\n    margin-top: calc(-1 * var(--text-offset));\n  }\n}\n\n/*\n * Unfortunately, the alert size default is not sensible, because usually we use the small size.\n * To mitigate issues with people forgetting to apply the small size, we make default alerts\n * *look* like small alerts in modals and popups.\n */\n:where(.d-modal, .d-popup) .d-alert,\n.d-alert-small {\n  --icon-size: 16px;\n  --padding-y: 8px;\n  --p-margin: 4px;\n\n  &:where(:not(:last-child)) {\n    margin-bottom: 6px;\n  }\n}\n\n.d-alert-xs {\n  --bg: transparent;\n  --icon-gap: 2px;\n  --p-margin: 4px;\n\n  padding: 0;\n\n  &:where(:not(:last-child)) {\n    margin-bottom: 4px;\n  }\n\n  @media (--hover) {\n    --icon-size: 16px; /* icon size 'xs' */\n  }\n}\n\n.d-alert-with-button {\n  align-items: flex-start;\n  display: flex;\n  justify-content: space-between;\n\n  & .d-alert--text + * {\n    margin-left: 8px;\n  }\n}\n\n.d-alert-with-button-bottom {\n  --button-gap: 8px;\n\n  & .d-alert--text ~ * {\n    margin: var(--button-gap) var(--button-gap) 0 0;\n  }\n\n  &.d-alert-small {\n    --button-gap: 4px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
var ___CSS_LOADER_STYLE_SHEET___ = new CSSStyleSheet();
___CSS_LOADER_STYLE_SHEET___.replaceSync(___CSS_LOADER_EXPORT___.toString());
export default ___CSS_LOADER_STYLE_SHEET___;
